import { Rect, Scale, Size } from ".././MyHelpers";
import { BigSymbolFreegamesCommonConfiguration, ISimpleBonusAction, JackpotValue2, SpinAndHoldCommonConfiguration } from "../api";
import { Track } from "../AudioManager";
import { IJackpotDisplay } from "../IJackpotDisplay";
import { IJackpotDisplayFactory } from "../IJackpotDisplayFactory";
import { JackpotDisplayFactory } from "../JackpotDisplayFactory";
import { JackpotDisplayParams } from "../JackpotDisplayParams";
import { MultigameParams } from "../MultigameParams";
import { FontResource } from "../ResourceManager/FontResource";
import { ImageResource } from "../ResourceManager/ImageResource";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../ResourceManager/ResourceManager";
import { service } from "../services";
import { InfoScreenSlider, JackpotDisplay, Settings } from "../Settings";
import { SlotGameInitData } from "../SlotGameInitData";
import { ZIndex } from "../ZIndex";
import { BigSymbolFreegamesBonusFactory_1Screen } from "./Bonus/BigSymbolFreegames/BigSymbolFreegamesBonusFactory_1Screen";

import { IRandomInterval } from "../Context/RandomInterval";
import { SpriteResource } from "../ResourceManager/SpriteResource";
import { availableSpinParams, ChangeSpeedFactor } from "../SpeedManager";
import { BigSymbolFreegamesBonusParams } from "./Bonus/BigSymbolFreegames/BigSymbolFreegamesParams";
import { BigSymbolSpinAndHoldBonusFactory_1Screen } from "./Bonus/BigSymbolSpinAndHold/BigSymbolSpinAndHoldFactory_1Screen";
import { Bonus } from "./Bonus/Bonus";
import { SlotBonus } from "./Bonus/SlotBonus";
import { SpinAndHoldBonusFactory_1Screen } from "./Bonus/SpinAndHold/SpinAndHold_1Screen";
import { SpinAndHoldParams } from "./Bonus/SpinAndHold/SpinAndHoldParams";
import { FreegameBonusParams } from "./FreegameBonus/FreegameBonus";
import { FreegameBonusFactory_1Screen } from "./FreegameBonus/FreegameBonus_1Screen";
import { Panel } from "./panel/panel";
import { PanelFactory } from "./panel/PanelFactory";
import { PickBonusFactory } from "./PickBonus/PickBonus";
import { PickBonusFactory_2Screen } from "./PickBonus/PickBonus_2Screen";
import { PickBonusParams } from "./PickBonus/PickBonusParams";
import { IGenericSlider } from "./Slider/GenericSlider";
import { ISlideFactoryGeneric } from "./Slider/ISlideFactory";
import { FactoryDoubleSlide1Screns } from "./Slider/Slide2/FactoryDoubleSlide";
import { SlotGameState } from "./SlotGameState";
import { SlotGameType1 } from "./SlotGameType1";
import { CanvasSprite } from "./Sprite/CanvasSprite";
import { MarkersInfoColors } from "./WinLineInfoMarkers";


export class SlotGameType1_1Screen extends SlotGameType1 {

	//USE FOR 2 SCREEN
	protected pickBonusFactory_2Screen: PickBonusFactory = new PickBonusFactory_2Screen();

	//Spin And Hold Bonus for 2 Screen
	protected spinAndHoldBonusFactory_1Screen: SpinAndHoldBonusFactory_1Screen = new SpinAndHoldBonusFactory_1Screen();
	//BIG SYMBOL FREE GAME SPIN AND HOLD FACTORY
	protected bigSymbolSpinAndHoldBonusFactory_1Screen: BigSymbolSpinAndHoldBonusFactory_1Screen = new BigSymbolSpinAndHoldBonusFactory_1Screen();
	//BIG SYMBOL FREE GAME 
	protected bigSymbolFreegameBonusFactory_1Screen: BigSymbolFreegamesBonusFactory_1Screen = new BigSymbolFreegamesBonusFactory_1Screen();
	protected freegameBonusFactory_1Screen: FreegameBonusFactory_1Screen = new FreegameBonusFactory_1Screen();
	//protected jackpotDisplay: JackpotDisplay1screen = null;
	protected _jackpotDisplay: IJackpotDisplay;

	protected get jackpotDisplay() : IJackpotDisplay { 
		return this._jackpotDisplay
	}
	protected set jackpotDisplay(val: IJackpotDisplay) { 
		this._jackpotDisplay = val
	}
	
	//variable to the factory
	protected JackpotDisplayFactory : IJackpotDisplayFactory= new JackpotDisplayFactory();
	protected viewSize: Size = null;
	protected jackpotTitleAnim: CanvasSprite = null; //Jubilee
	protected titleJPAnim: IRandomInterval;



	protected override panelFactory: PanelFactory = new PanelFactory();
	protected override panel: Panel = null;

	protected TitleContainer: HTMLElement = null;
	public JackpotTitleImg : HTMLElement;

	protected override colorLineMarkers: MarkersInfoColors =
	{
		MarkerbackgroundColor: "linear-gradient(90deg, rgba(6,65,42,1) 0%, rgba(117,255,9,1) 35%, rgba(183,255,9,1) 55%, rgba(117,255,9,1) 75%, rgba(6,65,42,1) 100%), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
		//linearColor:"linear-gradient(to left , transparent, LightGoldenrodYellow,transparent ) 0 10 100%",
	};

	public constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string) {
		super(multigameParams, initData, gameName);
		//this.panel = new PanelPyramid(this.systemContext, this.resid, "./", this.audio);

		//if (Settings.JackpotDisplay == JackpotDisplay.Enable) {
		if (initData.JackpotEnabled)
		{
			this.viewSize = new Size(Settings.ScreenWidth, Settings.ScreenHeight);
			//Interface with neccesary parameters for the jackpot
			let params: JackpotDisplayParams = {
				systemContext: this.systemContext,
				resid: this.resid,
				viewSize: this.viewSize,
				screenProtocol: this.screenProtocol
			};

			//ADD JACKPOT 
			this.jackpotDisplay = this.JackpotDisplayFactory.CreateNewJackpotDisplay(params);

			this.ProtocolSetup();

			
		}
		//this.AddScreenHelp();
	}

	protected ProtocolSetup(): void {

	    void service.api?.registerOperation("JackpotValuesUpdate", this.resid.ID(), (data) => { this.OnJackpotValues(Object.values(data.JackpotValues)) });
	}

	public override async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void>
	{
		await super.PrepareResources(loadingStage, resourceManager);

		if (loadingStage != LoadingStage.Games) {
			return;
		}

		await this.jackpotDisplay?.PrepareResources(loadingStage,resourceManager);
		
		await this.PrepareFonts(resourceManager);
		await this.PrepareTitle(resourceManager);
		await this.TitleJackpotAnimPrepared(resourceManager);
	}

	protected PrepareFonts(resourceManager: IWriteOnlyResourceManager): void 
	{
		
		resourceManager.Add(new FontResource(this.basepath +"resources/huggable.ttf",this.resid.ScopedResourceName(["BigSymbolFreeGames-font"])));
	
	}

	protected containerTitles : HTMLElement  = null;

	protected LoadTitle(resourceManager: IReadOnlyResourceManager) {


		this.containerTitles = document.createElement("div");
		this.containerTitles.style.position = "absolute";
		this.containerTitles.style.position = "center";
		this.containerTitles.style.alignContent = "center";
		this.containerTitles.setAttribute("class", "containerTitles-" + this.name);
		this.containerTitles.style.justifyContent = "center";		
		this.containerTitles.style.height = Scale.Hpx(180);
		this.containerTitles.style.width = "75%"//Scale.Wpx(1120);
		this.containerTitles.style.left = Scale.Xpx(0);
		this.containerTitles.style.top = "0px";
		this.containerTitles.style.display ="flex";
		this.containerTitles.style.flexDirection = "row";

		this.basegameElement.appendChild(this.containerTitles);
		


		this.TitleContainer = document.createElement("div");
		this.TitleContainer.style.display = "flex";
		this.TitleContainer.style.position = "center";
		this.TitleContainer.style.alignContent = "center";
		this.TitleContainer.setAttribute("class", "titleGame-" + this.name);
		this.TitleContainer.style.justifyContent = "center";		
		this.TitleContainer.style.height = Scale.Hpx(180);
		this.TitleContainer.style.width = "100%";
		// this.TitleContainer.style.left = Scale.Xpx(0);
		// this.TitleContainer.style.top = "0px";
		this.TitleContainer.style.background = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName(["title", this.name])).CssBackground(),
		this.TitleContainer.style.backgroundSize = "contain";
		this.TitleContainer.style.backgroundPosition = "center";
		this.TitleContainer.style.backgroundRepeat = "no-repeat";
		this.containerTitles.appendChild(this.TitleContainer);


		if (Settings.JackpotDisplay != JackpotDisplay.Disable) {
			this.JackpotTitleImg = document.createElement("div");
			this.JackpotTitleImg.setAttribute("class", "jackpotTitleImg-" + Settings.JackpotDisplayType);
			this.JackpotTitleImg.classList.add(this.resid.ScopedResourceName("JackpotTitleImg"));
			this.TitleContainer.style.display = "flex";
			this.JackpotTitleImg.style.position = "center";
			this.JackpotTitleImg.style.alignContent = "center";
			//this.JackpotTitleImg.style.top = Scale.Ypx(0);		
			//this.JackpotTitleImg.style.left = Scale.Xpx(500);
			this.JackpotTitleImg.style.height = Scale.Hpx(180);
			this.JackpotTitleImg.style.width = "100%";
			//this.JackpotTitleImg.style.backgroundImage = resourceManager.Get<ImageResource>(ResourceIdentifier.Global.Add("titleJackpotDisplaySlider-" + Settings.JackpotDisplayType)).CssBackground();
			this.JackpotTitleImg.style.backgroundPosition = "center";
			this.JackpotTitleImg.style.backgroundRepeat = "no-repeat";
			this.JackpotTitleImg.style.backgroundSize = "contain";
			this.jackpotTitleAnim = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(ResourceIdentifier.Global.Add("titleJackpotDisplay")).sprite, canvasSize: new Size(Scale.W(450), Scale.H(180))});
			this.JackpotTitleImg.appendChild(this.jackpotTitleAnim.View());
			this.containerTitles.appendChild(this.JackpotTitleImg);
			//this.jackpotTitleAnim.Start(true);
			this.titleJPAnim = this.systemContext.TimingContext().CreateRandomInterval("titleJackpotDisplay", 1500, 6000, () => this.jackpotTitleAnim.Start(false));			
		}
	}

	protected secondScreenHelp: IGenericSlider = null;
	protected seconScreenHelpFactory:ISlideFactoryGeneric= new FactoryDoubleSlide1Screns();
	public AddScreenHelp()
	{
		// if (Settings.JackpotSlider == InfoScreenSliderType.Enable) {
		// 	this.secondScreenHelp = this.seconScreenHelpFactory.Create({
		// 		systemContext: this.systemContext,
		// 		initData: this.initData,
		// 		resid: this.resid,
		// 		translator: this.translator,
		// 		logGroup: this.logGroup,
		// 		symbolSpriteAnims: this.symbolSpriteAnims,
		// 		viewSize: this.viewSize,
		// 		backendSettings: this.multigameParams.backendSettings,
		// 		availableSymbols: null
		// 	});			
		// }
		// else 
		// {
		// 	//DONT LOAD SLIDER 
		// }
		
		
	}



	//Title sprite animation Jacpot Jubilee
	protected TitleJackpotAnimPrepared(resourceManager: IWriteOnlyResourceManager){
		resourceManager.AddGlobal(new SpriteResource(Settings.ResourcesFolder+"multigame/multigame/img/JackpotsResources-Slider/"+Settings.JackpotDisplayType+"/titleJackpotDisplay",
		ResourceIdentifier.Global.Add("titleJackpotDisplay"),true, this.logGroup.Add("titleJackpotDisplay"),true));
	}

	protected PrepareTitle(resourceManager: IWriteOnlyResourceManager) {
		resourceManager.Add(new ImageResource(this.basepath + "resources/title.png", this.resid.ScopedResourceName(["title", this.name])));		
        resourceManager.AddGlobal(new ImageResource( Settings.ResourcesFolder + "multigame/multigame/img/JackpotsResources-Slider/"+Settings.JackpotDisplayType+"/titleJackpotDisplayImg.png",ResourceIdentifier.Global.Add("titleJackpotDisplaySlider-"+Settings.JackpotDisplayType).Scope()));
	}

	public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>
	{
		await super.ResourcesLoaded(loadingStage, resourceManager);

		if (loadingStage != LoadingStage.Games)
		{
			return;
		}
		
		if(Settings.JackpotSlider == InfoScreenSlider.Disable){
			//dont need slite use only title 
			this.LoadTitle(resourceManager);
		}else if(this.secondScreenHelp != null)	{
			await this.secondScreenHelp.ResourcesLoaded(resourceManager);
			this.basegameElement.appendChild(this.secondScreenHelp.View());
		}

		
		
        if (this.initData.JackpotEnabled)
        {

			if (this.jackpotDisplay)
			{
				await this.jackpotDisplay?.ResourcesLoaded(loadingStage,resourceManager);
				//ADD ZINDEX BECAUSE ITS HIDE WHEN YOU WIN SOME JACKPOT
				this.jackpotDisplay.View().style.zIndex = ZIndex.JackpotDisplay.toString();

				//this.view.appendChild(this.jackpotDisplay.View());
				this.AppendToView(this.jackpotDisplay.View())
				if (this.jackpotValuesBuffer != null) {
					this.OnJackpotValues(this.jackpotValuesBuffer);
				}
			}
		}

		// let Reels: HTMLElement = this.view.querySelector(".spinnablereels-slotwindow");
		// Reels.style.top = Scale.Xpx(184);

	}
	protected AppendToView(element: HTMLElement): void
	{
		if (element)
		{
			this.view.appendChild(element);
		}
		else
		{
			this.view.appendChild(element);
		}
	}

	protected override PreparedPanel(): void {
		this.panel = this.panelFactory.CreateNewPanel({
			systemContext: this.systemContext,
			resid: this.resid,
			resourcesBasePath: "./",
			audio: this.audio,
			backendSettings: this.multigameParams.backendSettings,
			translator: this.translator,
			panelColor:this.panelColor,
			doubleupEnabled: !!this.doubleUpView,
			symbolAnimationType : this.gameConfig.symbolsType,
		});

		service.translator?.SetOnLanguageChangedCallback((t) => {

            this.panel.SetMessage(this.clientState.Balance() <= 0 ? this.translator.t.message_insertcredit : this.translator.t.message_pressspin);

			if (this.turboSpin)
			{
				this.panel.SpinButtonLabelChange(t.turbo);
			}
			else
			{
				this.panel.SpinButtonLabelChange(t.spin);
			}
		});
	}

	protected jackpotValuesBuffer: JackpotValue2[] = null;

	public OnJackpotValues(data: JackpotValue2[]) {
		this.jackpotDisplay?.UpdateValues(data);
	}

	public override Update(): void {
		super.Update()
		this.jackpotDisplay?.Update();

		if(this.secondScreenHelp !=null){			
			this.secondScreenHelp.Update();			
		}
		this.jackpotTitleAnim?.Update();
	}


	protected override AudioPrepare(resourceManager: IWriteOnlyResourceManager): void {
		super.AudioPrepare(resourceManager);
		this.audio.AddTrack(new Track(this.commonpath + "resources/Dragontracks/pickbonusDragonLink" + Settings.audioFormat, this.resid.ScopedResourceName("pickbonus")));

	}

	protected override SetWindowsView(): void {
		let xratio = 0.8;
		let yratio = 0.8;

		let x = Scale.X(74.0) * xratio;
		
		if (Settings.JackpotDisplay == JackpotDisplay.Disable)
		{
			x = (Scale.W(1920) - (Scale.W(1774.0) * xratio)) / 2
		}

		this.windowRectangle = new Rect(x, Scale.Y(240) * yratio, Scale.W(1774.0) * xratio, Scale.H(885.0) * yratio);
		// if (Settings.JackpotDisplay == JackpotDisplay.Disable)
		// {
		// }
		// else
		// {
		// 	this.windowRectangle = new Rect(Scale.X(74), Scale.Y(240) * yratio, Scale.W(1774.0) * xratio, Scale.H(885.0) * yratio);
		// }
		
		this.windowSymbolSize = this.initData.PlayWindow;
	}


	// protected override GroowReel(reelWindowElement: HTMLElement, zoomFactor: number, scaleAnim: any, reelElement: HTMLElement) {
	// 	zoomFactor = 1.04;
	// 	reelWindowElement.style.transformOrigin = "top";
	// 	scaleAnim = TweenLite.to(reelWindowElement, 0.5, { scaleY: zoomFactor/*, backgroundColor: newBackgroundAnticipation.toRgba()*/ });
	// 	TweenLite.to(reelElement, 0.5, { scaleX: zoomFactor });
	// }

	// protected override GroowReelReset(reelWindowElement: HTMLElement, scaleAnim: any, reelElement: HTMLElement, oldZIndex: string) {
	// 	TweenLite.to(reelElement, 0.5, { scaleX: 1 });
	// 	scaleAnim = TweenLite.to(reelWindowElement, 0.5, {
	// 		scaleY: 1, /*backgroundColor: originalBackgroundAnticipation.toRgba(),*/
	// 		onComplete: () => {
	// 			reelWindowElement.style.zIndex = oldZIndex;
	// 		}
	// 	});
	// }






	protected override async PickBonusPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager) {
		
		let pickBonusparams: PickBonusParams =
		{
			systemContext: this.systemContext,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gameBonusResourcesBasePath: this.basepath + "resources/PickBonus/",
			commonBonusResourcesBasePath: this.commonpath + "resources/PickBonus/",
			bonusConfiguration: this.initData.BonusConfiguration.PickBonus,
			pickElementFactory: this.pickBonusFactory,
			screenSize: this.multigameParams.viewSize,
			panel: this.panel,
			audio: this.audio,
			translator: this.translator,
			robotPlay: this.robotPlay,
			slotGameMeta: this.initData.Meta,
			clientState: this.clientState,
			jackpotRequired: this.multigameParams.jackpotRequired,
			bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true)
		};

		//USE FOR 2 SCREEN

		let pickBonus: SlotBonus = this.pickBonusFactory_2Screen.CreatePickBonus(this.name, pickBonusparams);

		//change state when bonus is finished 
		//after bonus comes collect
		pickBonus.SetBonusFinishedCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinTotal));
		pickBonus.SetBonusPanelRequiredCallback((required: boolean) => {
			if (required)
				this.panel.Show();
			else
				this.panel.Hide();
		});

		await pickBonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.PickBonus, pickBonus);


	}

	protected override async FreegamesPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager) {

		let fgparams: FreegameBonusParams =
		{
			systemContext: this.systemContext,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gameResourcesBasePath: this.basepath,
			gameBonusResourcesBasePath: this.basepath + "resources/FreeGameBonus/",
			commonBonusResourcesBasePath: this.commonpath + "resources/FreeGameBonus/",
			screenSize: this.multigameParams.viewSize,
			windowSymbolSize: this.windowSymbolSize,
			windowRectangle: this.windowRectangle,
			symbolSpriteAnims: this.symbolSpriteAnims,
			symbolSpriteAnimsByName: this.symbolSpriteAnimsByName,
			playlines: this.playlines,
			//reelSet: this.initData.BonusConfiguration.FreeGameBonus.ReelSet,
			startPositions: this.initData.BonusConfiguration.FreeGameBonus.ReelSet.map(r => 0),
			panel: this.panel,
			audio: this.audio,
			color: this.color,
			lines: this.selectedBet.Lines,
			denom: this.selectedBet.Denom.InCents,
			bonusConfiguration: this.initData.BonusConfiguration.FreeGameBonus,
			pickElementFactory: this.freegameBonusFactory,
			// TODO duplicate with lines
			linesPlayed: this.selectedBet.Lines,

			clientState: this.clientState,
			translator: this.translator,
			robotPlay: this.robotPlay,
			slotGameMeta: this.initData.Meta,
			slotGameInitData: this.initData,
			slotGame: this,
			availableSymbols: this.symbols,
			availableSymbolsMap: this.symbolsMap,
			jackpotRequired: this.multigameParams.jackpotRequired,
			bonusList: this.bonusList,
			pixiSpritesByName: this.pixiSpritesByName,
			spinnableReelsParams: this.spinnableReelsParams,
			reelBackgroundTexture:this.reelBackgroundTexture,
			reelBackgroundMaskTexture:this.reelBackgroundMaskTexture,
			colorLineMarkers : this.colorLineMarkers,
			initData : this.initData,
			skinAttachmentFillingPotFeature : this.skinAttachmentFillingPotFeature,
			reelAnimationParams: availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
			winAnimationSpeedFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			gameConfig : this.gameConfig,
			backendSettings: this.multigameParams.backendSettings,
		};

		let freegameBonus: SlotBonus = this.freegameBonusFactory_1Screen.CreateFreegameBonus(this.gameName, fgparams);
		freegameBonus.SetBonusFinishedCallback(() => {
			this.OnBonusFinished();
		});

		freegameBonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
			this.OnBonusRunFinish(run);
		});


		// after bonus comes collect
		freegameBonus.SetBonusFinishedCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinTotal));
		freegameBonus.SetBonusPanelRequiredCallback((required: boolean) => {
			if (required)
				this.panel.Show();
			else
				this.panel.Hide();
		});

		await freegameBonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.FreeGameBonus, freegameBonus);
	}


	protected override async SpinAndHoldPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager) {

		let bonusParams: SpinAndHoldParams =
		{
			systemContext: this.systemContext,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gamepath: this.basepath,
			commonpath: this.commonpath,
			gameBonusResourcesBasePath: this.basepath + "resources/HoldAndSpin/",
			commonBonusResourcesBasePath: this.commonpath + "resources/HoldAndSpin/",
			screenSize: this.multigameParams.viewSize,
			// windowSymbolSize: this.windowSymbolSize,
			// windowRectangle: this.windowRectangle,
			symbolSpriteAnims: this.symbolSpriteAnims,
			symbolSpriteAnimsByName: this.symbolSpriteAnimsByName,
			playlines: this.playlines,
			symbols: this.symbols,
			spinnableReelsParams: this.spinnableReelsParams,
			//reelSet: <number[][]>this.initData.bonusConfiguration["SpinAndHoldBonus"].ReelSet,
			//startPositions: [0, 0, 0, 0, 0],
			panel: this.panel,
			audio: this.audio,
			// TODO remove
			lines: this.selectedBet.Lines,

			// TODO remove?
			denom: this.selectedBet.Denom.InCents,

			// TODO remove?
			linesPlayed: this.selectedBet.Lines,
			clientState: this.clientState,
			translator: this.translator,
			robotPlay: this.robotPlay,
			slotGameMeta: this.initData.Meta,
			slotGameInitData: this.initData,
			slotGame: this,
			color: this.color,
			jackpotEnable : this.multigameParams.jackpotRequired,
			bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true),
			pixiSpritesByName : this.pixiSpritesByName,
            jackpotDisplay: this.jackpotDisplay,
			reelAnimationParams: availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
			FpsFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			gameConfig : this.gameConfig,
		};

		let bonusConfig: SpinAndHoldCommonConfiguration = this.initData.BonusConfiguration.SpinAndHold;

		let spinAndHoldBonus: SlotBonus = this.spinAndHoldBonusFactory_1Screen.CreateSpinAndHoldBonus_1Screen(this.gameName, bonusParams, bonusConfig);

		// after bonus comes collect
		//spinAndHoldBonus.SetBonusFinishedCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinTotal));
		spinAndHoldBonus.SetBonusFinishedCallback(() => {
			this.OnBonusFinished();
		});

		spinAndHoldBonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
			this.OnBonusRunFinish(run);
		});

		spinAndHoldBonus.SetBonusPanelRequiredCallback((required: boolean) => {
			if (required)
				this.panel.Show();
			else
				this.panel.Hide();
		});

		await spinAndHoldBonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.SpinAndHold, spinAndHoldBonus);
	}


	protected override async BigSymbolFreegamesPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {

		let bonusParams: BigSymbolFreegamesBonusParams =
		{
			systemContext: this.systemContext,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			commonPath: this.commonpath,
			gamePath: this.basepath,
			screenSize: this.multigameParams.viewSize,
			playWindow: this.windowSymbolSize,
			windowRectangle: this.windowRectangle,
			symbolSpriteAnims: this.symbolSpriteAnims,
			symbolSpriteAnimsByName: this.symbolSpriteAnimsByName,
			playlines: this.playlines,
			symbols: this.symbols,
			spinnableReelsParams: this.spinnableReelsParams,
			//reelSet: <number[][]>this.initData.bonusConfiguration["SpinAndHoldBonus"].ReelSet,
			//startPositions: [0, 0, 0, 0, 0],
			panel: this.panel,
			audio: this.audio,

			// TODO remove
			lines: this.selectedBet.Lines,

			// TODO remove?
			denom: this.selectedBet.Denom.InCents,

			// TODO remove?
			linesPlayed: this.selectedBet.Lines,

			clientState: this.clientState,
			translator: this.translator,
			robotPlay: this.robotPlay,
			slotGameMeta: this.initData.Meta,
			slotGameInitData: this.initData,
			slotGame: this,
			color: this.color,
			jackpotEnable: this.multigameParams.jackpotRequired,
			bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true),
			bonusList: this.bonusList,
			reelAnimationParams: availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
			FpsFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			winAnimationFactor:ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			gameConfig: this.gameConfig,
		};

		let bonusConfig: BigSymbolFreegamesCommonConfiguration = this.initData.BonusConfiguration.BigSymbolFreegames;

		let bonus: SlotBonus = this.bigSymbolFreegameBonusFactory_1Screen.CreateBigSymbolFreegamesBonus_1Screen(this.gameName, bonusParams, bonusConfig) as unknown as SlotBonus;

		// after bonus comes collect
		//spinAndHoldBonus.SetBonusFinishedCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinTotal));
		bonus.SetBonusFinishedCallback(() => {
			this.OnBonusFinished();
		});

		bonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
			this.OnBonusRunFinish(run);
		});

		bonus.SetBonusPanelRequiredCallback((required: boolean) => {
			if (required)
				this.panel.Show();
			else
				this.panel.Hide();
		});

		await bonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.BigSymbolFreegames, bonus);
	}

	protected override async BigSymbolSpinAndHoldPrepare(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void> {

		let bonusParams: SpinAndHoldParams =
		{
			systemContext: this.systemContext,
			resid: this.resid,
			logGroup: this.logGroup,
			screenProtocol: this.screenProtocol,
			screenProtocolScope: this.screenProtocolScope,
			gamepath: this.basepath,
			commonpath: this.commonpath,
			gameBonusResourcesBasePath: this.basepath + "resources/HoldAndSpin/",
			commonBonusResourcesBasePath: this.commonpath + "resources/HoldAndSpin/",
			screenSize: this.multigameParams.viewSize,
			// windowSymbolSize: this.windowSymbolSize,
			// windowRectangle: this.windowRectangle,
			symbolSpriteAnims: this.symbolSpriteAnims,
			symbolSpriteAnimsByName: this.symbolSpriteAnimsByName,
			playlines: this.playlines,
			symbols: this.symbols,
			spinnableReelsParams: this.spinnableReelsParams,
			//reelSet: <number[][]>this.initData.bonusConfiguration["SpinAndHoldBonus"].ReelSet,
			//startPositions: [0, 0, 0, 0, 0],
			panel: this.panel,
			audio: this.audio,
			// TODO remove
			lines: this.selectedBet.Lines,

			// TODO remove?
			denom: this.selectedBet.Denom.InCents,

			// TODO remove?
			linesPlayed: this.selectedBet.Lines,

			clientState: this.clientState,
			translator: this.translator,
			robotPlay: this.robotPlay,
			slotGameMeta: this.initData.Meta,
			slotGameInitData: this.initData,
			slotGame: this,
			color: this.color,
			jackpotEnable : this.multigameParams.jackpotRequired,
			bonusAutoplay: this.multigameParams.backendSettings.GetBool("play.bonusautoplay", true),
			pixiSpritesByName : this.pixiSpritesByName,
			reelAnimationParams:availableSpinParams[this.speedManager.GetDefaultReelSpeedType()],
			FpsFactor: ChangeSpeedFactor[this.speedManager.GetDefaultCelebrationType()],
			gameConfig : this.gameConfig,
		};

		let bonusConfig: SpinAndHoldCommonConfiguration = this.initData.BonusConfiguration.BigSymbolSpinAndHold;

		let spinAndHoldBonus: SlotBonus = this.bigSymbolSpinAndHoldBonusFactory_1Screen.CreateBigSymbolSpinAndHoldBonus1_Screen(this.gameName, bonusParams, bonusConfig);

		// after bonus comes collect
		//spinAndHoldBonus.SetBonusFinishedCallback(() => this.stateMachine.ChangeState(SlotGameState.BigWinTotal));
		spinAndHoldBonus.SetBonusFinishedCallback(() => {
			this.OnBonusFinished();
		});

		spinAndHoldBonus.SetBonusRunFinishedCallback((run: ISimpleBonusAction[]) => {
			this.OnBonusRunFinish(run);
		});

		spinAndHoldBonus.SetBonusPanelRequiredCallback((required: boolean) => {
			if (required)
				this.panel.Show();
			else
				this.panel.Hide();
		});

		await spinAndHoldBonus.PrepareResources(loadingStage, resourceManager);

		this.bonusList.set(Bonus.BigSymbolSpinAndHold, spinAndHoldBonus);
	}

	public override GameSelected(): void {
		if (this.stateMachine.IsState(SlotGameState.Idle)) {
			this.spinnableReels.Create();
			this.bonusList.forEach((bonus) => bonus.GameSelected());
			this.ShowGame()
			this.audio.PlayOrContinueLoop(this.resid.ScopedResourceName("background"));
			//Show denom when you enter game 
			//only show if you have 2 denom for select 
			//if not are some auto select.
			//always need change denom because not are the same for all games 
			this.showDenomMenu = false;
		}
		if (this.secondScreenHelp != null) {
			this.secondScreenHelp.Start();
		}
		this.titleJPAnim?.Start();
	}



	public override GameExit() {
		super.GameExit();
		if(this.secondScreenHelp != null)
		{
		this.secondScreenHelp.Reset();
		this.secondScreenHelp.Stop();
		}
		this.titleJPAnim?.Start();
	}

	protected override OnBonusBegin() {
		super.OnBonusBegin()

		if (this.runingBonuses.length != 0) {
			if (this.secondScreenHelp != null) {
				this.secondScreenHelp.Reset();
				this.secondScreenHelp.Stop();
			}
		}
	}
	protected override OnBonusEnd() {
		super.OnBonusEnd();
		if (this.secondScreenHelp != null) {
			this.secondScreenHelp.Start();
		}
	}

    public override OnWaitGameStartBegin(): void {
        this.jackpotDisplay?.Pause();
        super.OnWaitGameStartBegin();
    }

    public override OnSpinBegin(): void {
        super.OnSpinBegin();
    }
    
    public override OnIdleBegin(): void {
        this.jackpotDisplay?.Resume();
        super.OnIdleBegin();
    }

	protected override BasegamePrepare(resourceManager: ResourceManager) {}	

	protected override BasegameLoaded(resourceManager: IReadOnlyResourceManager) {}
}
